/** First strong isolate and pop directional isolate (Unicode UAX #9): invisible marks that fence a run of text. */
const FIRST_STRONG_ISOLATE = String.fromCodePoint(0x2068);
const POP_DIRECTIONAL_ISOLATE = String.fromCodePoint(0x2069);
const ISOLATE_MARKS = new RegExp(`[${FIRST_STRONG_ISOLATE}${POP_DIRECTIONAL_ISOLATE}]`, 'g');

const NOT_A_LETTER = /\P{L}/gu;
// Letters only: Arabic-Indic digits are Arabic script too, and a number has no direction to keep.
const RIGHT_TO_LEFT_LETTERS = /[\p{Script=Arabic}\p{Script=Hebrew}\p{Script=Syriac}\p{Script=Thaana}\p{Script=Nko}]/gu;

/**
 * Fences a value put into a sentence when its letters run against the sentence (GAPS E25). Unfenced, a Latin name
 * in an Arabic sentence, or an Arabic one in an English sentence, pulls the punctuation and digits beside it to its
 * own side. A value that runs the sentence's way, or has no letter at all (a formatted number, a date, a time, a
 * phone number), is left as it is, so the text a person reads and the accessible names stay unchanged.
 */
export function isolate(value: string | number | undefined, direction: 'rtl' | 'ltr'): string {
  const text = String(value);
  return runsAgainst(text, direction) ? `${FIRST_STRONG_ISOLATE}${text}${POP_DIRECTIONAL_ISOLATE}` : text;
}

/** A sentence as data, without the marks `isolate` added: for text the API keeps, such as a subject. */
export function withoutIsolates(text: string): string {
  return text.replace(ISOLATE_MARKS, '');
}

function runsAgainst(text: string, direction: 'rtl' | 'ltr'): boolean {
  const letters = text.replace(NOT_A_LETTER, '');
  const leftToRight = letters.replace(RIGHT_TO_LEFT_LETTERS, '');
  return direction === 'ltr' ? leftToRight.length < letters.length : leftToRight.length > 0;
}
